import React from 'react';
import { useTranslations } from 'next-intl';

import { courseConst, ILesson, IModule } from 'modules/courses';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import { Header } from './header';
import { Lesson } from './lesson';
import { ModuleLesson } from './module-lesson';

interface IProps {
  modules?: IModule[];
  lessons?: ILesson[];
  type?: courseConst.CourseLesssonType;
  stats?: {
    duration?: number;
    lesson_count?: number;
  };
}

export const CourseContents = ({ lessons, stats, modules, type }: IProps) => {
  const t = useTranslations();

  return (
    <div className="my-6 space-y-3">
      <Header lessonCount={stats?.lesson_count} duration={stats?.duration} />

      <Visible
        if={isEmptyArr(lessons)}
        else={
          <Visible
            if={type === courseConst.CourseLesssonType.MODULAR}
            else={lessons?.map(lesson => (
              <Lesson
                key={lesson?.id}
                duration={lesson?.duration}
                title={lesson?.title}
                slug={lesson?.slug}
                progress={lesson?.progress}
                available={lesson?.open}
              />
            ))}
          >
            <ModuleLesson modules={modules}>
              {lesson => (
                <Lesson
                  key={lesson?.id}
                  duration={lesson?.duration}
                  title={lesson?.title}
                  slug={lesson?.slug}
                  progress={lesson?.progress}
                  available={lesson?.open}
                />
              )}
            </ModuleLesson>
          </Visible>
        }
      >
        <EmptyData title={t('profile.no_data')} />
      </Visible>
    </div>
  );
};
